import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/medservices/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/medservices/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/medservices/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/medservices/src/components/QualityPolicySection.tsx");
